import React from 'react';
import { useEscapeKey } from '../../hooks/useEscapeKey';
import { X } from 'lucide-react';
import { EngagementForm } from './EngagementForm';
import { useEngagements } from '../../hooks/useEngagements';
import { Engagement } from '../../types/engagement';

interface EditEngagementPopupProps {
  engagement: Engagement;
  onClose: () => void;
  onSuccess: () => void;
}

export default function EditEngagementPopup({ 
  engagement,
  onClose, 
  onSuccess 
}: EditEngagementPopupProps) {
  useEscapeKey(onClose);
  const { updateEngagement } = useEngagements();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-dark-800 rounded-lg max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold">Edit Engagement</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <EngagementForm 
          engagement={engagement}
          onSubmit={async (data) => {
            try {
              await updateEngagement(engagement.id, data);
              await onSuccess();
              onClose();
            } catch (err) {
              console.error('Failed to update engagement:', err);
            }
          }}
          onCancel={onClose}
        />
      </div>
    </div>
  );
}
